import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { CheckoutB2BModule } from '@spartacus/checkout/b2b'
import { CheckoutPaymentTypeAdapter } from '@spartacus/checkout/b2b/core'
import { CheckoutPaymentTypeFacade } from '@spartacus/checkout/b2b/root'
import { CheckoutModule } from '@spartacus/checkout/base'
import {
  CartNotEmptyGuard,
  CheckoutAuthGuard,
  CheckoutComponentsModule,
  CheckoutGuard,
  CheckoutStepsSetGuard
} from '@spartacus/checkout/base/components'
import { CheckoutDeliveryAddressFacade, CheckoutDeliveryModeEventListener, CheckoutRootModule, CheckoutStepType } from '@spartacus/checkout/base/root'
import { CheckoutScheduledReplenishmentModule } from '@spartacus/checkout/scheduled-replenishment'
import { I18nModule, provideConfig, UrlModule } from '@spartacus/core'
import {
  CardModule,
  DIALOG_TYPE,
  GenericLinkModule,
  IconModule,
  LayoutConfig,
  PageLayoutComponent,
  SpinnerModule,
  TableModule, TruncateTextPopoverModule
} from '@spartacus/storefront'
import { AddressFormModule } from "@spartacus/user/profile/components"
import { EbCheckoutStepButtonsModule } from '../../components/checkout-step-buttons/eb-checkout-step-buttons.module'
import { EbDatalistModule } from '../../components/datalist/eb-datalist.module'
import { EbDatePickerModule } from '../../components/date-picker/eb-date-picker.module'
import { EbCardModule } from '../../components/eb-card/eb-card.module'
import { EbGenericPageStepperModule } from '../../components/generic-page-stepper/eb-generic-page-stepper.module'
import { EbInfoBoxModule } from '../../components/info-box/eb-info-box.module'
import { EbModalModule } from '../../components/modal/eb-modal.module'
import { EbSpinnerModule } from '../../components/spinner/eb-spinner.module'
import { EbAuthGuard } from '../auth/guards/eb-auth.guard'
import { EbCartModule } from '../cart/eb-cart.module'
import { EbActiveCartService } from '../cart/services/eb-active-cart.service'
import { EbMultiCartService } from '../cart/services/eb-multi-cart.service'
import '../checkout/models/eb-checkout-models'
import { EbFormModule } from '../form/eb-form.module'
import {
  EbOrderDetailDocumentsComponent
} from '../order/components/eb-order-detail-documents/eb-order-detail-documents.component'
import { EbOrderDetailItemsComponent } from '../order/components/eb-order-detail-items/eb-order-detail-items.component'
import {
  EbOrderDetailOverviewComponent
} from '../order/components/eb-order-detail-overview/eb-order-detail-overview.component'
import { EbOrderDetailTotalComponent } from '../order/components/eb-order-detail-total/eb-order-detail-total.component'
import {
  EbCheckoutProgressMobileTopComponent
} from './components/checkout-progess-mobile-top/eb-checkout-progress-mobile-top.component'
import { EbCheckoutProgressComponent } from './components/checkout-progress/eb-checkout-progress.component'
import { EbDeliveryModeComponent } from './components/delivery-mode/eb-delivery-mode.component'
import {
  EbOrderConfirmationItemsComponent,
  EbOrderConfirmationOverviewComponent,
  EbOrderConfirmationThankYouMessageComponent,
  EbOrderConfirmationTotalsComponent,
  EbOrderOverview
} from './components/order-confirmation/components'
import { EbCheckoutOrderSummaryComponent } from './components/order-summary/eb-checkout-order-summary.component'
import { EbPaymentMethodComponent } from './components/payment-method/eb-payment-method.component'
import { EbPlaceOrderComponent } from './components/place-order/eb-place-order.component'
import { EbReviewSubmitComponent } from './components/review-submit/eb-review-submit.component'
import { EbShippingAddressDialogComponent } from './components/shipping-address/eb-shipping-address-dialog.component'
import { EbShippingAddressComponent } from './components/shipping-address/eb-shipping-address.component'
import { EbShippingAddressCardComponent } from './components/shipping-address/shipping-address-card/eb-shipping-address-card.component'
import { EbShippingAddressDeleteModalComponent } from "./components/shipping-address/shipping-address-delete-modal/eb-shipping-address-delete-modal.component"
import {EbCheckoutDeliveryModeEventListener} from "./events/eb-checkout-delivery-mode-event.listener";
import { EbCheckoutStepsSetGuard } from './guards/eb-checkout-steps-set.guard'
import { EbCheckoutAdapter } from './services/connectors/eb-checkout.adapter'
import { EbPaymentTypeAdapter } from './services/connectors/eb-payment-type.adapter'
import { EbRequestedShippingDateAdapter } from './services/connectors/eb-requested-shipping-date.adapter'
import { EbCardConstructorService } from './services/eb-card-constructor.service'
import { EbCheckoutDeliveryService } from './services/facades/eb-checkout-delivery.service'
import { EbPaymentTypeService } from './services/facades/eb-payment-type.service'

export const defaultCheckoutDialogModalLayoutConfig: LayoutConfig = {
  launch: {
    EDIT_ADDRESS: {
      inlineRoot: true,
      component: EbShippingAddressDialogComponent,
      dialogType: DIALOG_TYPE.POPOVER_CENTER_BACKDROP
    },
    DELETE_ADDRESS: {
      inlineRoot: true,
      component: EbShippingAddressDeleteModalComponent,
      dialogType: DIALOG_TYPE.POPOVER_CENTER_BACKDROP
    }
  }
}

@NgModule({
  imports: [
    CheckoutRootModule,
    CheckoutModule,
    CheckoutB2BModule,
    CheckoutScheduledReplenishmentModule,
    CheckoutComponentsModule,
    RouterModule.forChild([
      {
        path: 'checkout',
        canActivate: [EbAuthGuard, CheckoutGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'checkout' }
      }
    ]),
    I18nModule,
    CommonModule,
    ReactiveFormsModule,
    UrlModule,
    RouterModule,
    EbGenericPageStepperModule,
    AddressFormModule,
    SpinnerModule,
    CardModule,
    EbCheckoutStepButtonsModule,
    IconModule,
    EbCartModule,
    EbDatePickerModule,
    EbSpinnerModule,
    GenericLinkModule,
    EbDatalistModule,
    FormsModule,
    EbCardModule,
    EbModalModule,
    EbFormModule,
    EbInfoBoxModule,
    TableModule,
    TruncateTextPopoverModule
  ],
  providers: [
    provideConfig(defaultCheckoutDialogModalLayoutConfig),
    provideConfig({
      checkout: {
        steps: [
          // Change the payment details step to be before the delivery mode
          {
            id: 'paymentDetails',
            name: 'checkoutProgress.paymentDetails',
            routeName: 'checkoutPaymentDetails',
            type: [CheckoutStepType.PAYMENT_DETAILS]
          },
          {
            id: 'deliveryAddress',
            name: 'checkoutProgress.deliveryAddress',
            routeName: 'checkoutDeliveryAddress',
            type: [CheckoutStepType.DELIVERY_ADDRESS]
          },
          {
            id: 'deliveryMode',
            name: 'checkoutProgress.deliveryMode',
            routeName: 'checkoutDeliveryMode',
            type: [CheckoutStepType.DELIVERY_MODE]
          },
          {
            id: 'reviewOrder',
            name: 'checkoutProgress.reviewOrder',
            routeName: 'checkoutReviewOrder',
            type: [CheckoutStepType.REVIEW_ORDER]
          }
        ]
      },
      cmsComponents: {
        CheckoutProgressMobileTop: {
          component: EbCheckoutProgressMobileTopComponent,
          guards: [EbAuthGuard, CartNotEmptyGuard, EbCheckoutStepsSetGuard]
        },
        CheckoutProgress: {
          component: EbCheckoutProgressComponent,
          guards: [EbAuthGuard, CartNotEmptyGuard, EbCheckoutStepsSetGuard]
        },
        CheckoutPaymentDetails: {
          component: EbPaymentMethodComponent,
          // The default CheckoutPaymentDetails uses the DeliveryModeSetGuard, but in this case, the delivery mode details will not be set yet.
          // Instead, override the component guards with a new set that does not include the DeliveryModeSetGuard
          guards: [EbAuthGuard, CartNotEmptyGuard]
        },
        CheckoutDeliveryAddress: {
          component: EbShippingAddressComponent,
          guards: [EbAuthGuard, CartNotEmptyGuard]
        },
        CheckoutDeliveryMode: {
          component: EbDeliveryModeComponent,
          // The default CheckoutPaymentDetails uses the DeliveryModeSetGuard, but in this case, the delivery mode details will not be set yet.
          // Instead, override the component guards with a new set that does not include the DeliveryModeSetGuard
          guards: [EbAuthGuard, CartNotEmptyGuard]
        },
        CheckoutReviewOrder: {
          component: EbReviewSubmitComponent
        },
        CheckoutPlaceOrder: {
          component: EbPlaceOrderComponent
        },
        CheckoutOrderSummary: {
          component: EbCheckoutOrderSummaryComponent
        },
        OrderConfirmationThankMessageComponent: {
          component: EbOrderConfirmationThankYouMessageComponent
        },
        OrderConfirmationItemsComponent: {
          component: EbOrderConfirmationItemsComponent
        },
        OrderConfirmationTotalsComponent: {
          component: EbOrderConfirmationTotalsComponent
        },
        OrderConfirmationOverviewComponent: {
          component: EbOrderConfirmationOverviewComponent
        }
      }
    }),
    {
      provide: CheckoutPaymentTypeAdapter,
      useClass: EbPaymentTypeAdapter
    },
    {
      provide: CheckoutStepsSetGuard,
      useClass: EbCheckoutStepsSetGuard
    },
    {
      provide: CheckoutAuthGuard,
      useClass: EbAuthGuard
    },
    {
      provide: CheckoutDeliveryAddressFacade,
      useClass: EbCheckoutDeliveryService
    },
    {
      provide: CheckoutPaymentTypeFacade,
      useClass: EbPaymentTypeService
    },
    {
      provide: ActiveCartFacade,
      useClass: EbActiveCartService
    },
    {
      provide: MultiCartFacade,
      useClass: EbMultiCartService
    },
    {
      provide: CheckoutDeliveryModeEventListener,
      useClass: EbCheckoutDeliveryModeEventListener
    },
    EbRequestedShippingDateAdapter,
    EbCheckoutAdapter,
    EbCardConstructorService
  ],
  declarations: [
    EbCheckoutProgressMobileTopComponent,
    EbCheckoutProgressComponent,
    EbShippingAddressComponent,
    EbPaymentMethodComponent,
    EbDeliveryModeComponent,
    EbReviewSubmitComponent,
    EbPlaceOrderComponent,
    EbCheckoutOrderSummaryComponent,
    EbOrderConfirmationThankYouMessageComponent,
    EbOrderConfirmationItemsComponent,
    EbOrderConfirmationTotalsComponent,
    EbOrderConfirmationOverviewComponent,
    EbOrderOverview,
    EbOrderDetailOverviewComponent,
    EbOrderDetailTotalComponent,
    EbOrderDetailItemsComponent,
    EbOrderDetailDocumentsComponent,
    EbShippingAddressDialogComponent,
    EbShippingAddressDeleteModalComponent,
    EbShippingAddressCardComponent
  ]
})
export class EbCheckoutModule { }
